import { Helmet } from 'react-helmet';
import { VerificationFormContainer } from '../components/verification-form.container';

export const ToolsVerificationForm: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Tools - Verification Form</title>
      </Helmet>
      <VerificationFormContainer />
    </>
  );
};
